import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import GenericPaymentMethod from './GenericPaymentMethod';
import ApplePayIcon from 'components/Common/Icons/Payment/ApplePay';
import useApplePayCompatibility from 'hooks/useApplePayCompatibility';
import PaymentMethod from 'model/PaymentMethod';
import { MethodProps } from 'types/PaymentFormType';

import styles from './PaymentMethod.module.scss';

export default function ApplePayPaymentMethod({
  isSelected,
  setPaymentMethod,
}: MethodProps): JSX.Element {
  const { t } = useTranslation(['checkout']);
  const { isCompatible, loading } = useApplePayCompatibility();

  useEffect(() => {
    if (isSelected && !isCompatible) {
      void setPaymentMethod(undefined);
    }
  }, [isSelected, isCompatible]);

  return (
    <GenericPaymentMethod
      value={PaymentMethod.applePay}
      onClick={() => {
        if (isCompatible) void setPaymentMethod(PaymentMethod.applePay);
      }}
      classes={{
        methodTitle: styles.appleMethodTitle,
      }}
      labelContent={
        <>
          <span className={styles.methodLogo}>
            <ApplePayIcon className={styles.appleIcon} />
          </span>
          <span className={styles.methodText}>
            {t('APPLE_PAY_METHOD_TITLE')}
          </span>
        </>
      }
      isDisabled={loading || !isCompatible}
    />
  );
}
